import { useState } from "react";
import { Col, Row } from "reactstrap";

type TPaperCopyRequestProps = {
  onConfirm: (paperCopyRequest: boolean) => void;
  onCancel: (paperCopyRequest: boolean) => void;
  orderSignerAddress: string;
}

const PaperCopyRequest = ({ onConfirm, onCancel, orderSignerAddress }: TPaperCopyRequestProps) => {

  const [paperCopyRequest, setPaperCopyRequest] = useState(false);

  return <div className="px-3 agreement-container paper-copy-request">
    <Row className="justify-content-center">
      <Col md={7}>
        <h5 className="agreement-title mb-5">Paper Copy Request</h5>
        <div className="agreement-content px-5 py-5">
          <div className="form-check my-2">
            <input
              className="form-check-input"
              type="checkbox"
              name="isPaperCopyRequired"
              id="isPaperCopyRequired"
              value={paperCopyRequest ? "1" : "0"}
              checked={paperCopyRequest}
              onChange={(e) => setPaperCopyRequest(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="readAndUnderstand">I am requesting a paper copy of all signed documents. <br /> Delivery address: {orderSignerAddress}</label>
          </div>
        </div>


        <div className="text-center mt-5">Make sure this is the correct address and if not, please contact your dealer.</div>
        <div className="d-flex justify-content-center mt-5">
          <button
            onClick={() => onCancel(paperCopyRequest)}
            disabled={paperCopyRequest}
            className="px-5 py-2 mx-2 btn btn-secondary">
            Skip, I prefer the digital version
          </button>
          <button
            onClick={() => onConfirm(paperCopyRequest)}
            disabled={!paperCopyRequest}
            className="px-5 py-2 mx-2 btn btn-primary"
          >
            Save
          </button>
        </div>
      </Col>
    </Row>
  </div>
}

export default PaperCopyRequest;
